import { environment } from "src/environments/environment";
import { AppName } from "../types/environment.type";
import {
  ROUTE_PATH,
  ROUTE_PATH_GLOBAL,
  ROUTE_PATH_PUBLIC_SITE,
  ROUTE_PATH_USER_ADMIN,
  ROUTE_PATH_USER_CONSUMER,
  ROUTE_PATH_USER_MERCHANT,
  ROUTE_PATH_USER_STAFF,
  ROUTE_PATH_USER_SUPPLIER
} from "../types/route.type";

export const getEnvironmentAuthRoute = (): ROUTE_PATH_GLOBAL => {
  return ROUTE_PATH_GLOBAL.Authenticate;
};

export const getApiUserAccessRole = (app?: AppName | string): string => {
  return (app || '').toLowerCase();
};

export const getEnvironmentRedirectRoute = (): string => {
  const activeApp = (environment.app || '').toLowerCase();
  const loggedIn = isUserLoggedIn();

  switch (activeApp) {
    case AppName.Admin:
      return loggedIn
        ? `${ROUTE_PATH.UserAdmin}/${ROUTE_PATH_USER_ADMIN.Dashboard}`
        : `${ROUTE_PATH.UserAdmin}/${ROUTE_PATH_USER_ADMIN.Home}`;
    case AppName.Consumer:
      return loggedIn
        ? `${ROUTE_PATH.UserConsumer}/${ROUTE_PATH_USER_CONSUMER.Dashboard}`
        : `${ROUTE_PATH.UserConsumer}/${ROUTE_PATH_USER_CONSUMER.Home}`;
    case AppName.Merchant:
      return loggedIn
        ? `${ROUTE_PATH.UserMerchant}/${ROUTE_PATH_USER_MERCHANT.Dashboard}`
        : `${ROUTE_PATH.UserMerchant}/${ROUTE_PATH_USER_MERCHANT.Home}`;
    case AppName.Staff:
      return loggedIn
        ? `${ROUTE_PATH.UserStaff}/${ROUTE_PATH_USER_STAFF.Dashboard}`
        : `${ROUTE_PATH.UserStaff}/${ROUTE_PATH_USER_STAFF.Home}`;
    case AppName.Supplier:
      return loggedIn
        ? `${ROUTE_PATH.UserSupplier}/${ROUTE_PATH_USER_SUPPLIER.Dashboard}`
        : `${ROUTE_PATH.UserSupplier}/${ROUTE_PATH_USER_SUPPLIER.Home}`;
    case AppName.Site:
    default:
      return `${ROUTE_PATH.PublicSite}/${ROUTE_PATH_PUBLIC_SITE.Home}`;
  }
};

export const isUserLoggedIn = (): boolean => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }
    const sessionStr = window.localStorage.getItem('session');
    if (!sessionStr) return false;
    const session = JSON.parse(sessionStr);
    return !!(session && (session.token || session.uuidRGumsUser || session.uuidRGamsSession));
  } catch {
    return false;
  }
};
